import axios from "axios";

export const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const apiClient = axios.create({ baseURL: API });

apiClient.interceptors.request.use((cfg) => {
  const token = localStorage.getItem("ba_token");
  if (token) cfg.headers.Authorization = `Bearer ${token}`;
  return cfg;
});

export function wsUrl() {
  const url = BACKEND_URL.replace(/^http/, "ws");
  return `${url}/api/ws/match`;
}
